<template>
  <div class="p-col-12">
    <div class="card">
      <h5>CSV</h5>
      <router-link to="/csv/create">
        <Button label="Nuevo" style="width: 10rem" />
      </router-link>
      <Button @click="getAll()" class="p-button-success">Refresh</Button>

      <DataTable
        :value="items"
        scrollHeight="400px"
        :loading="loading2"
        scrollDirection="vertical"
        class="p-mt-3"
      >
        <Column field="id" header="Id" :style="{ width: '300px' }"></Column>
        <Column field="plantilla.empresa.name" header="Empresa"></Column>
        <Column field="plantilla.name" header="Plantilla"></Column>
        <Column field="status" header="Status"></Column>
        <Column
          header="Acciones"
          :exportable="false"
          :style="{ width: '200px' }"
          bodyClas="p-ml-auto"
        >
          <template #body="{data}">
            <Button
              :disabled="data.status != 'Generado'"
              icon="pi pi-send"
              class="p-button-rounded p-button-primary p-mr-2"
              @click="procesar(data.id)"
            />

            <router-link v-bind:to="`/csv/detail/${data.id}`">
              <Button
                :disabled="data.status == 'Generado'"
                icon="pi pi-key"
                class="p-button-rounded p-button-success p-mr-2"
              />
            </router-link>

            <Button
              :disabled="!isAdmin && data.status != 'Generado'"
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger p-mr-2"
              @click="borrar(data.id)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { apiGet, apiDelete, apiPost } from '../../helpers/rest-api';
import { isUserAdmin } from '../../helpers/security';
export default {
  data() {
    return { items: [], isAdmin: false };
  },
  mounted() {
    apiGet(`proceso`).then((response) => (this.items = response.data));
    this.isAdmin = isUserAdmin();
  },
  methods: {
    getAll() {
      apiGet('proceso').then((response) => (this.items = response.data));
    },

    borrar(index) {
      apiDelete('proceso/' + index).then(() => this.getAll());
    },

    procesar(id) {
      //apiPost(`csv/process/${id}`, {}).then();
      apiPost(`csv/send/${id}`, {}).then();

      this.getAll();
    },
  },
};
</script>
